export interface ILogin {
    email: string;
    password: string;
}

export interface IRefresh {
    refresh_token: string;
    user_id: string;
}

export interface ILoginv2 {
    username: string;
    password: string;
}

export interface IAgentLoginInfo {
    username: string;
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    bankBsb: string;
    bankAccount: string;
    bankCountryShortCode: string;
    businessnumber: string;
    tradingname: string;
}

export interface IGoogleLogin {
    google_access_token: string;
}
export interface IAppleLogin {
    access_token: string;
}

export interface ISignUp {
    email: string;
    password: string;
}
export interface ISignUpEmail {
    email: string;
}

export interface ISignUpPassword {
    password: string;
    ReEnterPassword: string;
}

export interface ILoginDemo {
    email: string;
    password: string;
}

export interface IAuthAgentData {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    username: string;
    user_id: string;
    updated_at: string;
    created_at: string;
    id: number;
}

export interface IJwtData {
    accessToken: string;
    refreshToken: string;
}

export interface IAuth {
    success: boolean;
    data: IAuthAgentData;
    message: string;
    code: number;
}

export enum IAuthType {
    EMAIL = "email",
    APPLE = "apple",
    GOOGLE = "google",
    FACEBOOK = "facebook",
}

export interface IAccountResponse {
    success: boolean;
    title: string;
    data: IAccount;
    code: number;
}

export interface IAccount {
    id: string;
    first_name: string | null;
    last_name: string | null;
    email: string;
    sso_type: IAuthType;
    profile_status: string;
    is_agent_integrated: boolean;
    date_of_birth: string;
    is_email_verified: boolean;
    created_at: string;
    phone_number: string;
    post_code: string;
    country_code: string;
}

export interface IAuthLogin {
    success: boolean;
    title: string;
    data: {
        accessToken: string;
        refreshToken: string;
    };
    code: number;
}

export interface IRefreshAccessToken {
    accessToken: string;
}
export interface ISetRealEmail {
    new_email: string;
}

export interface IVerifyRealEmail {
    otp: string;
}

export interface IForgotPassEmail {
    email: string;
}
export interface IForgotPassword {
    new_password: string;
}
export interface IChangePassword {
    new_password: string;
    current_password: string;
}

export interface IAuthenticationCode {
    otp: string;
}

export interface IResetPassword {
    password: string;
    confirmPassword: string;
}

export interface IAgentInfo {
    bankBsb: string;
    bankAccount: string;
    bankCountryShortCode?: string;
    businessnumber: string;
    tradingname: string;
}
